// TIC-9577: BUG-1146 (RenderInput.js) auto-adds whatever single product sits in
// `options` when Enter is pressed. Product-search screens call their un-debounced
// (or coarsely debounced) handleSearch on every keystroke/scan without cancelling
// prior in-flight searches, so a barcode scan's rapid keystrokes can leave a stale
// search resolving seconds later, re-arming the auto-add for a product that was
// already added directly by the scan itself -- landing on the *next* Enter (often
// the next scan) and silently double-adding.
//
// This counter lets each handleSearch invalidate itself: bump on every new search
// attempt and on every completed scan, capture the value at the start of a search,
// and skip applying the result if the counter has moved on by the time it resolves.
let generation = 0;

export const bumpSearchGeneration = () => {
  generation += 1;
  return generation;
};

export const currentSearchGeneration = () => generation;
